/**
 * Application root.
 *
 * Composition only — the provider stack lives in `app/provider.tsx` and the
 * route table in `app/routes.tsx`.
 */
import { BrowserRouter } from 'react-router-dom';

import { AppProviders } from '@/app/provider';
import { AppRoutes } from '@/app/routes';
import { ErrorBoundary } from '@/components/core/common/boundaries/ErrorBoundary';
import { printEnvironmentInfo } from '@/config/env';

// Print environment info in development
if (import.meta.env.MODE === 'development') {
  printEnvironmentInfo();
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppProviders>
          <AppRoutes />
        </AppProviders>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
